import {A11y} from "swiper/modules";

document.addEventListener('DOMContentLoaded', (e) => {

    const blocks = document.querySelectorAll('.block--cards');

    function create_block_cards() {

        return {
            block: null,

            init: function (block) {
                this.block = block;

                if (this.block.getAttribute('data-mobile') === 'slider') {
                    this.slider('mobile')
                } else if (this.block.getAttribute('data-layout') === 'slider') {
                    this.slider('all')
                }
            },

            slider: function (level = 'all') {

                if (level === 'all') {
                    // if not have .swiper-slide items then add class to .cards

                    const cards = this.block.querySelectorAll('.block--cards-card');
                    // if cards do not have class .swiper-slide then add class
                    cards.forEach(card => {
                        if (!card.classList.contains('swiper-slide')) {
                            card.classList.add('swiper-slide');
                        }
                    })

                    this.swiper();
                }

                if (level === 'mobile') {
                    console.log('mobile')
                    const target = this.block.querySelector('.cards');

                    const swiper = document.createElement('div');
                    swiper.classList.add('swiper', 'd-md-none', 'p-4--');

                    const wrapper = document.createElement('div');
                    wrapper.classList.add('swiper-wrapper');

                    let cards = this.block.querySelectorAll('.block--cards-card');
                    cards.forEach(card => {
                        wrapper.appendChild(card.cloneNode(true));
                        wrapper.lastChild.classList.add('swiper-slide');
                    })

                    const pagination = document.createElement('div');
                    pagination.classList.add('swiper-pagination', 'd-md-none');

                    swiper.appendChild(wrapper);
                    target.parentNode.insertBefore(swiper, target.nextSibling);
                    target.parentNode.insertBefore(pagination, swiper.nextSibling);

                    this.swiper();
                }
            },

            swiper: function () {
                const swiperWrapper = this.block.querySelector('.swiper-wrapper');

                const options = {
                    slidesPerView: swiperWrapper.dataset.swiperSlidesPerView ? swiperWrapper.dataset.swiperSlidesPerView : 5,
                }

                var swiper = new Swiper(this.block.querySelector('.swiper'), {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: false,
                    loop: true,
                    a11y: {
                        enabled: true,
                    },
                    pagination: {
                        el: this.block.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        nextEl: this.block.querySelector('.swiper-button-next'),
                        prevEl: this.block.querySelector('.swiper-button-prev')
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: options.slidesPerView,
                        }
                    },
                    modules: [Navigation, Pagination, A11y]
                });
            },

            log: function (message) {
                console.log(message);
            }
        }
    }

    blocks.forEach(block => {
        const block_cards = create_block_cards();
        block_cards.init(block);
    });
});